
type CardThreeProps = {
  icon? : {
    src : string;
    alt : string;
  },
  title? : string;
  subtitle? : string;
  list? : string[]
}

const CardThree = ({ 
  icon,
  title,
  subtitle,
  list,
} : CardThreeProps) => {
  return (
    <div className="card-three">
      {icon ? <img src={icon.src} className="card-icon" alt="" aria-hidden="true" /> : ""}
      <h3 className="card-title">{title}</h3>
      <p className="card-subtitle">
        {subtitle}
        <ul className="list-normal">
        {list ?
        list?.map((item, index) => (
          <li key={index}>{item}</li>
        )) : ""}
        </ul>
      </p>
    </div>
  )
}

export default CardThree